<template>
     <div class="guest-wrapper register-wrapper">
        <div class="guest-logo">
            <img src="/images/new_logo_v2.png" width="220"/>
        </div>
        <div class="row">
            <div class="col-md-6 col-xs-12 ml-auto mr-auto mt-5">
                <div class="card card-white">
                    <div class="card-body">
                        <div v-if="user">
                          <div class="fpx-carousel-body">
                            <VueSlickCarousel v-bind="sliderSettings">
                              <div class="carousell-1 d-flex flex-column align-items-center justify-content-center">
                                <img src="/images/new_investor_carousell/you_are_almost_done_edit.png" id="you_are_almost_done_img" alt="You are almost done">
                                <div class="modal-new-investor-body-text carousell-1-title">
                                  <h2>You're almost done!</h2>
                                </div>
                                <div class="modal-new-investor-body-text carousell-1-text">
                                  <h4>Next up... FPX Verification</h4>
                                </div>
                              </div>
                              <div class="carousell-2 d-flex flex-column align-items-center justify-content-center">
                                <img src="/images/new_investor_carousell/one_time_deposit_edit.png" id="one_time_deposit_img" alt="One time deposit">
                                <div class="modal-new-investor-body-text carousell-2-title">
                                  <h2>One time deposit</h2>
                                </div>
                                <div class="modal-new-investor-body-text carousell-2-text">
                                  <h4>Please make a minimum deposit of RM200 <br/>via FPX Online Banking using your personal bank.</h4>
                                </div>
                              </div>
                              <div class="carousell-3 d-flex flex-column align-items-center justify-content-center">
                                <img src="/images/new_investor_carousell/not_registration_fees_edit.png" id="not_registration_fees_img" alt="Not registration fees">
                                <div class="modal-new-investor-body-text carousell-3-title">
                                  <h2>It's not registration fees</h2>
                                </div>
                                <div class="modal-new-investor-body-text carousell-3-text">
                                  <h4>The deposit ensures your bank<br/> account matches your personal details.</h4>
                                </div>
                              </div>
                              <div class="carousell-4 d-flex flex-column align-items-center justify-content-center">
                                <img src="/images/new_investor_carousell/invest_or_withdraw_edit.png" id="invest_or_withdraw_img" alt="Invest or Withdraw">
                                <div class="modal-new-investor-body-text carousell-4-title">
                                  <h2>Invest or withdraw</h2>
                                </div>
                                <div class="modal-new-investor-body-text carousell-4-text">
                                  <h4>Your deposit. <br/>Invest or withdraw, you're in control.</h4>
                                </div>
                              </div>
                              <div class="carousell-5 d-flex flex-column align-items-center justify-content-center">
                                <img src="/images/new_investor_carousell/no_online_banking_edit.png" id="no_online_banking_img" alt="No online banking">
                                <div class="modal-new-investor-body-text carousell-5-title">
                                  <h2>No online banking?</h2>
                                </div>
                                <div class="modal-new-investor-body-text carousell-5-text">
                                  <h4>No problem, contact us at <br/><span id="carousell-email"><a href="mailto:contact@capsphere.com.my">contact@capsphere.com.my</a></span></h4>
                                </div>
                              </div>
                            </VueSlickCarousel>
                          </div>
<!--                            <p class="mt-2 mb-3">
                              As part of our due diligence check, please make an one-time top-up via FPX Online Banking (RM 200.00 for retail bank and corporate bank).
                              <br/> Kindly ensure that top up is made via bank account registered under the <b>same name</b> as your Capsphere's account.
                              <br/> Don't worry this is just a deposit into your account with us, which you can use the amount to invest or you can withdraw it as well. For investor who have no access to online banking, please contact us at <a href="mailto:contact@capsphere.com.my">contact@capsphere.com.my.</a>
                            </p>-->
                            <div class="form-group mt-4">
                                <label>Top Up amount</label>
                                <div class="input-group mb-1">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text" style="height: min-content; font-size: 0.8em">
                                            {{ currency }}
                                        </div>
                                    </div>
                                    <input type="number"
                                           v-model="topup_amount"
                                           :min="topup_default"
                                           max="2"
                                           :disabled="topUpLoading"
                                           @blur="checkTopupAmount"
                                           class="form-control"/>
                                </div>

                                <p class="small text-danger" v-if="topup_amount < minTopUpAmount">
                                    Minimum top up of {{ currency }} {{ minTopUpAmount+'.00' }}.
                                </p>
                            </div>
                            <button class="btn btn-success btn-block" dusk="submit-topup"
                                    :disabled="topUpLoading"
                                    v-on:click="topup">
                                <span v-if="topUpLoading">Loading ...</span>
                                <span v-else>
                                        Proceed To Top up
                                    </span>
                            </button>
                        </div><!--/.user-->
                        <hr/>
                        <a href="#" v-on:click.prevent="backToDashboard()" class="btn btn-block mt-3 btn-secondary">Back to Dashboard</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import UserSettingService from "../services/UserSettingService";
    import { api, siteName } from '../config'
    import jwtToken from '../helpers/jwt-token';
    import eventUuid from "../helpers/event-uuid";
    import VueSlickCarousel from 'vue-slick-carousel'
    import 'vue-slick-carousel/dist/vue-slick-carousel.css'
    // optional style for arrows & dots
    import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

    export default {
        name: 'FpxVerification',
        components: {
          VueSlickCarousel
        },
        created () {
          if (this.$store.state.auth) {
            this.user = this.$store.state.auth;
          }
        },
        computed: {
          minTopUpAmount () {
            if (this.user) {
              return 200
            }
          }
        },
        watch: {
          topup_amount () {
            if (this.topup_amount < 0) {
              this.topup_amount = -this.topup_amount;
            }
          }
        },
        data () {
          return {
            currency: 'RM',
            user: null,
            errors: [],

            // top up
            topUpLoading: false,
            topup_amount: 200,
            topup_payment_type: 'fpx',
            topup_default: 200,

            // Vue Slick Carousell settings
            sliderSettings: {
              arrows: false,
              dots: true,
              autoplay: true,
              autoplaySpeed: 3000,
            },
          }
        },
        methods: {
          checkTopupAmount () {
            if (this.user) {
              if (this.topup_amount < 200) {
                this.topup_amount = 200; // minimum of 1 for normal invest
              }
            }
          },
          topup () {
              if(this.topup_amount < this.minTopUpAmount) {
                return;
              }

              this.topUpLoading = true;
              UserSettingService.postTopUp(this.topup_amount, this.topup_payment_type, true)
                  .then((res) => {
                    if (res.data.link) {
                      window.location.href = res.data.link;
                    } else {
                      this.$noty.error('Unable to top up, try again later.');
                    }
                    this.topUpLoading = false;
                  })
                  .catch((err) => {
                    this.$noty.error('Unable to top up, try again later.');
                    this.topUpLoading = false;
                    if (typeof err.response != 'undefined' && err.response.status === 422) {
                      Object.keys(this.errors).forEach((key,index) => {
                        if (typeof err.response.data[key] !== 'undefined') {
                          this.errors[key] = err.response.data[key];
                        }
                      });
                    }
                  })
            },
            logout () {
              axios
                  .post(api.logout, {
                      eventUuid: eventUuid.getEventUuid()
                  })
                  .then((res) => {
                      this.$router.push({'name' : 'login'}); // go to login page

                      this.$store.dispatch('unsetAuthUser')
                          .then(() => {
                              jwtToken.removeToken();
                              eventUuid.removeEventUuid();
                              this.$noty.success('You are logged out');
                              this.$router.push({name: 'login'});
                          });

                  })
                  .catch((err) => {
                      this.$noty.error('Something went wrong, unable to logout')
                  })
            },
            backToDashboard () {
              this.$router.push({name: 'dashboard'})
            }
        }
    }
</script>
<style lang="scss">
.fpx-carousel-body {
  background-image: url('/images/new_investor_carousell/background.png');
  background-size : cover;
  max-width: 500px;
  max-height: 500px;
}
.fpx-carousel-body img{
  display:none;
}
.modal-new-investor-body-text {
  h2 {
    color:#60175b;
    font-weight: bold;
    text-align: center;
  }
  h4 {
    color:white;
    text-align:center;
  }
}
.carousell-1 {
  margin-top: 10%;
}
.carousell-1-title{
  margin-top:3%;
}
.carousell-2 {
  margin-top: 6%;
}
.carousell-2-title {
  margin-top: 4%;
}
.carousell-3 {
  margin-top: 12%;
}
.carousell-3-title {
  margin-top: 4%
}
.carousell-4 {
  margin-top: 10%;
}
.carousell-4-title {
  margin-top: 5%
}
.carousell-5 {
  margin-top: 10%;
}
.carousell-5-title {
  margin-top: 4%;
}
#carousell-email {
  a {
    color:white;
    &:hover {
      color:blue;
    }
  }
}
#you_are_almost_done_img {
  max-width: 20%;
}
#one_time_deposit_img{
  max-width:35%;
}
#not_registration_fees_img {
  max-width: 35%;
}
#invest_or_withdraw_img {
  max-width: 55%;
}
#no_online_banking_img {
  max-width: 50%;
}

</style>